module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "select-container clearfix",
    staticStyle: {
      "margin-top": "2%",
      "margin-left": "2%",
      "float": "left"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "30px",
      "font-weight": "bold"
    }
  }, [_vm._v("Windows操作系统安装MOA")]), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "28px",
      "font-weight": "bold"
    }
  }, [_vm._v("1、Windows操作系统版本要求")]), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "background": "#CCFFFF",
      "width": "100%",
      "height": "30px"
    }
  }, [_c('span', [_c('p', [_vm._v("Windows 7及以上版本")])])]), _vm._v(" "), _c('span', [_vm._v("查看Windows操作系统版本：右键“计算机”，选择“属性”，查看计算机版本。")]), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/moaInstallForWin/moaInstallForWin_pic01.png"),
      "width": "840px",
      "height": "360px"
    }
  }), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "28px",
      "font-weight": "bold"
    }
  }, [_vm._v("2、Windows版MOA下载")]), _c('br'), _c('br'), _vm._v(" "), _c('table', {
    attrs: {
      "border": "1",
      "cellpadding": "10",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tr', [_c('th', [_vm._v("下载地址")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1、"), _c('a', {
    staticClass: "ct-link",
    staticStyle: {
      "color": "#1890ff"
    },
    attrs: {
      "data-auto_update": "0",
      "data-pageid": "",
      "href": "https://itportal.sankuai.com/",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("https://itportal.sankuai.com/")]), _vm._v("\n            （首选从IT门户下载最新稳定版）")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "28px",
      "font-weight": "bold"
    }
  }, [_vm._v("3、MOA安装流程")]), _c('br'), _c('br'), _vm._v(" "), _c('span', [_vm._v("a、双击运行安装包或者右键安装包选择“以管理员身份运行”，然后一路“下一步”进行安装。")]), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/moaInstallForWin/moaInstallForWin_pic02.png"),
      "width": "540px",
      "height": "360px"
    }
  }), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/moaInstallForWin/moaInstallForWin_pic03.png"),
      "width": "540px",
      "height": "360px"
    }
  }), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/moaInstallForWin/moaInstallForWin_pic04.png"),
      "width": "540px",
      "height": "360px"
    }
  }), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/moaInstallForWin/moaInstallForWin_pic05.png"),
      "width": "540px",
      "height": "360px"
    }
  }), _c('br'), _vm._v(" "), _c('br'), _vm._v("b、安装成功后会跳出扫码登陆界面，如果未跳出该界面，请找到MOA客户端，点击打开。使用大象扫码登陆或选择输入账号密码登陆。"), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/moaInstallForWin/moaInstallForWin_pic06.png"),
      "width": "540px",
      "height": "360px"
    }
  }), _c('br'), _vm._v(" "), _c('br'), _vm._v("扫码登陆成功后会跳出“用户协议签署”，请仔细阅读“安全管理客户端用户协议”后，然后选择“同意”。"), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/moaInstallForWin/moaInstallForWin_pic07.png"),
      "width": "540px",
      "height": "360px"
    }
  }), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "28px",
      "font-weight": "bold"
    }
  }, [_vm._v("4、安装完成确认")]), _c('br'), _c('br'), _vm._v(" "), _c('span', [_vm._v("a、客户端在线确认")]), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/moaInstallForWin/moaInstallForWin_pic08.png"),
      "width": "540px",
      "height": "360px"
    }
  }), _c('br'), _vm._v(" "), _c('span', [_vm._v("b、安装版本确认")]), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/moaInstallForWin/moaInstallForWin_pic09.png"),
      "width": "540px",
      "height": "360px"
    }
  }), _c('br'), _vm._v(" "), _c('span', [_vm._v("c、绑定MOA账号确认")]), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/moaInstallForWin/moaInstallForWin_pic10.png"),
      "width": "540px",
      "height": "360px"
    }
  }), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "28px",
      "font-weight": "bold"
    }
  }, [_vm._v("5、安装异常解决")]), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "25px",
      "font-weight": "bold"
    }
  }, [_vm._v("5.1  SSO登陆超时")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("未及时扫码登陆MOA，重新启动MOA客户端即可。")]), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/moaInstallForWin/moaInstallForWin_pic11.png"),
      "width": "280px",
      "height": "200px"
    }
  }), _c('br')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-50db1234!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/moaInstallForWin.vue
// module id = 646
// module chunks = 1